// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__30LZq","col":"Table_col__1Rg1K","fulfillmentStatus":"Table_fulfillmentStatus__1C-KY","emailCol":"Table_emailCol__2SDbB"};